import * as React from "react"
import { useEditorState } from "@tiptap/react"
import { Button } from "../../tiptap-ui-primitive/button"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"

export const BlockquoteButton: React.FC = () => {
  const editor = useTiptapEditor()

  const state = useEditorState({
    editor,
    selector: (ctx) => ({
      isActive: ctx.editor?.isActive("blockquote") ?? false,
      canToggle: ctx.editor?.can().toggleBlockquote() ?? false,
    }),
  })

  const handleClick = () => {
    if (!editor) return
    editor.chain().focus().toggleBlockquote().run()
  }

  return (
    <Button
      onClick={handleClick}
      data-active={state.isActive}
      data-disabled={!state.canToggle}
      disabled={!state.canToggle}
      aria-label="Цитата"
      title="Цитата"
    >
      "
    </Button>
  )
}
